import React, { Children, PureComponent, ReactElement } from 'react';

import { TextAPI } from '@philips-emr/tws-components-api';
import { Size, TextAlignment } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, bool, element, expression, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid } from '@philips-emr/tws-utils';

import './text.scss';

export interface TextProps {
  alignment?: TextAlignment;
  bold?: boolean;
  children?: ReactElement | ReactElement[] | string;
  className?: string;
  size?: Size;
  value: string;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: TextAPI })
class Text extends PureComponent<TextProps> {

  static propTypes = {
    alignment: oneOf(enumValues(TextAlignment)),
    bold: bool,
    children: oneOfType([element, arrayOf(element), string]).notEnumerable(),
    className: string,
    size: oneOf(enumValues(Size)),
    value: expression,
  };

  static defaultProps = {
    alignment: TextAlignment.INITIAL,
    bold: false,
    size: Size.SMALL,
    value: '',
  };

  getTextValue = (): string => {
    const { children, value } = this.props;

    if (Children.count(children) === 1 && typeof children === 'string') {
      return children;
    }

    return value;
  };

  getClassName(): string {
    const { size, className, alignment, bold } = this.props;

    return classNames({
      'c-text': true,
      'u-text-bold': Boolean(bold),
      [`c-text--${size}`]: isEnumValid(Size, size),
      [`u-text-${alignment}`]: isEnumValid(TextAlignment, alignment),
      [`${className}`]: Boolean(className),
    });
  }

  render(): ReactElement {
    return (
      <div className={this.getClassName()}>{msg(this.getTextValue())}</div>
    );
  }
}

export default Text;
